// import React from "react";
import React, { useEffect, useState } from "react";
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";


// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from "react-bootstrap";

import firebase from "../firebase";

function rostermanagement() {

  const[afirstname,setAfirstname] = useState('');//
  const[aLastname,setAlastname] = useState('');//
  const[aStartTime,setAStartTime] = useState('');//
  const[aEndTime,setAEndTime] = useState('');//
  const[aADate,setAdate] = useState('');//
  const[aAbtme,setAabtme] = useState('');//

  const handleAddUser = () => {

   
    const firestore = firebase.database().ref("/assignshedules");
    let data = {
     
    
      FirstName: afirstname,
      LastName: aLastname,
      StartTime: aStartTime,
      EndTime: aEndTime,
      Date: aADate,
      AboutMe: aAbtme,

    
    }
    console.log(data);
    firestore.push(data);

    alert("Succfully inserted");
    setAfirstname("");
    setAlastname("");
    setAStartTime("");
    setAEndTime("");
    setAdate("");
    setAabtme("");


   };

  
  return (
    <>


 
    <Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

    
      <Container fluid>
        <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Make a Shedule</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Driver Firstname</label>
                        <Form.Control
                          focus value = {afirstname} onChange={(e)=>{setAfirstname(e.target.value)}}
                          placeholder="firstname"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>Driver Lasttname</label>
                        <Form.Control
                          focus value = {aLastname} onChange={(e)=>{setAlastname(e.target.value)}}
                          placeholder="lastname"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>starting time</label>
                        <Form.Control
                          focus value = {aStartTime} onChange={(e)=>{setAStartTime(e.target.value)}}
                          placeholder="First Name"
                          type="time"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>ending time</label>
                        <Form.Control
                          focus value = {aEndTime} onChange={(e)=>{setAEndTime(e.target.value)}}
                          placeholder="Last Name"
                          type="time"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>Date</label>
                        <Form.Control
                          focus value = {aADate} onChange={(e)=>{setAdate(e.target.value)}}
                          placeholder="date"
                          type="date"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About todays Shedule</label>
                        <Form.Control
                          cols="80"
                          focus value = {aAbtme} onChange={(e)=>{setAabtme(e.target.value)}}
                          placeholder="description about today shedule"
                          rows="4"
                          as="textarea"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button
                    onClick={()=>{handleAddUser()}}
                    className="btn-fill pull-right"
                    type="button"
                    variant="info"
                  >
                    Submit
                  </Button>
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
        
        </Row>
      </Container>

      </Col>
  </Row>
</Container>

<Footer /> 


    </>
  );
}


export default rostermanagement;
